import * as yup from "yup";

export const schema = (t: any) => {
  return yup
    .object({
      email: yup
        .string()
        .test(
          "emails",
          t("shareScreen.input.error.validEmail.text"),
          (value) => {
            if (value) {
              const emails = value.split(",");
              for (let i = 0; i < emails.length; i++) {
                if (!/^\S+@\S+\.[A-Za-z]{2,}$/.test(emails[i].trim())) {
                  return false;
                }
              }
            }
            return true;
          }
        )
        .required(t("shareScreen.input.error.required.text")),
      comments: yup.string(),
    })
    .required();
};
